import styled from '@emotion/styled';

export const DrawerContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
